import { styled } from 'stitches.config'
import { Proteins } from 'models/Pet'

export const HeroRoot = styled('div', {
  flex: 1,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'row',
  background: '$tertiary-200',

  variants: {
    color: {
      default: {
        background: '$tertiary-200',
      },
      [Proteins.BEEF]: {
        background: '$quaternary-100',
      },
      [Proteins.CHICKEN]: {
        background: '$quaternary-200',
      },
      [Proteins.DUCK]: {
        background: '$quaternary-300',
      },
      [Proteins.TURKEY]: {
        background: '$quaternary-400',
      },
      [Proteins.LAMB]: {
        background: '$quaternary-500',
      },
      [Proteins.VENISON]: {
        background: '$quaternary-600',
      },
    },
  },

  defaultVariants: {
    color: 'default'
  },

  '.cta': {
    display: 'none',

    '@bp3': {
      cursor: 'pointer',
      display: 'inline-flex',
    },
  },

  '& .d-only': {
    display: 'none',
    '@bp3': { display: 'flex' },
  },
})

export const Container = styled('div', {
  display: 'flex',
  width: '100%',
  maxWidth: '460px',
  flexDirection: 'column-reverse',
  margin: 'auto',
  alignItems: 'center',

  '@bp3': {
    alignItems: 'flex-start',
    maxWidth: '1920px',
    flexDirection: 'row',
  },
})

export const ContentContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  alignItems: 'center',
  padding: '30px 12px 0px 12px',

  '@bp3': {
    padding: '20px 24px 0px 24px',
    width: '50%',
  },

  variants: {
    padding: {
      false: {
        '@bp3': {
          paddingTop: '20px',
        },
      },
      true: {
        '@bp3': {
          paddingTop: '168px',
        },
      },
    },
  },
})

export const MobileWrapper = styled('div', {
  textAlign: 'center',
  display: 'block',
  '@bp3': {
    display: 'none',
  },
})

export const DesktopWrapper = styled('div', {
  width: '100%',
  display: 'none',
  '@bp3': {
    display: 'block',
  },
})